(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-faq"]) return;
  try {
    
    // Function to toggle section visibility
    function toggleSection(sectionId) {
      const sections = document.querySelectorAll(".sprig-accordion");
      sections.forEach(function(section) {
        if (section.id === sectionId) {
          section.classList.remove("hidden");
          let firstButton = section.querySelector('.sprig-accordion-btn');
          if(firstButton) {
            if(!firstButton.nextElementSibling.classList.contains('active-tab')) {
               firstButton.click();
            } 
          }
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        } else {
          section.classList.add("hidden");
          let firstButton = section.querySelector('.active');
          if(firstButton) {
               firstButton.click();
          }
        }
      });
    }

    // Add event listeners to menu items
    const menuItems = document.querySelectorAll(".menu a");
    let actItem = menuItems[0];
    actItem.classList.add('active')
    menuItems.forEach(function(item) {
      item.addEventListener("click", function(event) {
        event.preventDefault(); // Prevent default link behavior
        console.log(actItem)
        actItem.classList.remove('active')
        actItem = this;
        this.classList.add('active')
        const sectionId = this.getAttribute("href").substring(1); // Get section ID from href
        toggleSection(sectionId);
      });
    });

  document.addEventListener("DOMContentLoaded", function() {
    const questions = document.querySelectorAll(".sprig-accordion-btn");
    if(questions.length) {
      let actTab = questions[0].nextElementSibling;
      questions.forEach(function(question) {
        question.addEventListener("click", function() {
          this.classList.toggle("active");
          const answer = this.nextElementSibling;
          if (answer.style.height === "0px" || !answer.style.height) {
            answer.classList.add('active-tab');
            answer.style.height = answer.scrollHeight + "px";
          } else {
            answer.classList.remove('active-tab');
            answer.style.height = "0px";
          }
          console.log(actTab, answer, answer)
          if(actTab !== answer) {
            actTab.classList.remove('active-tab');
            actTab.style.height = "0px";
            actTab.previousElementSibling.classList.remove('active')
            actTab = answer;
          }
        });
      });
      questions[0].click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var norm = function (s) { return (s || '').toString().toLowerCase().replace(/\s+/g, ''); };
  var busy = false, timer = null;

  function variantsData() {
    var el = document.querySelector('product-info variant-selects script[type="application/json"]');
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function optionsOf(v) {
    return v.options || [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
  }

  /* 1. Cascading picker: each option shows only values that still have an AVAILABLE
        variant for the options chosen before it. Sold-out / non-existent values are hidden. */
  function hideUnavailable() {
    var info = document.querySelector('product-info');
    var variants = variantsData();
    if (!info || !variants) return;

    var groups = info.querySelectorAll('variant-selects .product-form__input');
    var earlier = [];
    var clickTarget = null;

    Array.prototype.forEach.call(groups, function (group, k) {
      var items = [];
      group.querySelectorAll('input[type="radio"]').forEach(function (r) {
        items.push({
          value: r.value,
          selected: r.checked,
          hide: function (h) {
            r.style.display = h ? 'none' : '';
            var l = r.nextElementSibling;
            if (l && l.tagName === 'LABEL') l.style.display = h ? 'none' : '';
          },
          pick: function () { if (r.nextElementSibling) r.nextElementSibling.click(); }
        });
      });
      group.querySelectorAll('select').forEach(function (s) {
        Array.prototype.forEach.call(s.options, function (o) {
          items.push({
            value: o.value,
            selected: o.selected,
            hide: function (h) { o.hidden = h; },
            pick: function () { s.value = o.value; s.dispatchEvent(new Event('change', { bubbles: true })); }
          });
        });
      });
      if (!items.length) return;

      var avail = items.map(function (it) {
        return variants.some(function (v) {
          if (!v.available) return false;
          var o = optionsOf(v);
          if (o[k] !== it.value) return false;
          for (var i = 0; i < k; i++) { if (o[i] !== earlier[i]) return false; }
          return true;
        });
      });
      var any = avail.some(Boolean);          // fully sold out -> hide nothing
      items.forEach(function (it, i) { it.hide(any && !avail[i]); });

      var selIdx = -1;
      items.forEach(function (it, i) { if (it.selected) selIdx = i; });
      earlier[k] = selIdx > -1 ? items[selIdx].value : undefined;
      if (any && selIdx > -1 && !avail[selIdx] && !clickTarget) {
        clickTarget = items[avail.indexOf(true)];
      }
    });

    if (clickTarget && !busy) {
      busy = true;
      clickTarget.pick();
      setTimeout(function () { busy = false; }, 700);
    }
  }

  /* 2. Gallery: image alt text is "<Option1>-<Option2>", show the exact match */
  function selectedValues() {
    var vals = [];
    document.querySelectorAll('product-info variant-selects .product-form__input').forEach(function (g) {
      var r = g.querySelector('input[type="radio"]:checked');
      var s = g.querySelector('select');
      if (r) vals.push(r.value); else if (s) vals.push(s.value);
    });
    return vals;
  }

  function filterGallery() {
    var slides = document.querySelectorAll('media-gallery .slider__slide');
    if (!slides.length) return;
    var vals = selectedValues();
    if (!vals.length) return;
    var combo = norm(vals.join('-'));

    var matches = [];
    slides.forEach(function (slide) { matches.push(norm(slide.dataset.mediaAlt) === combo); });
    var anyMatch = matches.some(Boolean);       // no image tagged for this combo -> show all

    var count = 0;
    slides.forEach(function (slide, idx) {
      var show = !anyMatch || matches[idx];
      slide.style.display = show ? 'block' : 'none';
      if (show) count++;
      var thumb = document.querySelector('.thumbnail-list__item[data-target="' + slide.id.replace(/^Slide-/, '') + '"]');
      if (thumb) thumb.style.display = show ? 'block' : 'none';
    });
    var total = document.querySelector('media-gallery .slider-counter--total');
    if (total) total.textContent = count;
    var firstThumb = document.querySelector('.thumbnail-list__item[style*="block"] button');
    if (firstThumb) firstThumb.click();
  }

  function sync() { hideUnavailable(); filterGallery(); }
  function syncLater() { clearTimeout(timer); timer = setTimeout(sync, 80); }

  document.addEventListener('DOMContentLoaded', function () {
    sync();
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('product-info variant-selects')) {
        syncLater();
        setTimeout(sync, 500);
      }
    });
    var info = document.querySelector('product-info');
    if (info && window.MutationObserver) {
      new MutationObserver(syncLater).observe(info, { childList: true, subtree: true });
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, syncLater);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
